import React, { useCallback } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useDropzone } from "react-dropzone";

interface UploadStepProps {
  file: File | undefined;
  onFile: (file: File) => void;
}

export const UploadStep: React.FC<UploadStepProps> = ({ file, onFile }) => {
  const onDrop = useCallback(
    (accepted: File[]) => {
      if (accepted[0]) onFile(accepted[0]);
    },
    [onFile]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: { "text/csv": [".csv"] },
  });

  return (
    <Grid container spacing={2.5} direction="column">
      <Grid item>
        <Typography variant="body2" color="text.secondary">
          Upload the CSV file with Entrata IDs filled in.
        </Typography>
      </Grid>
      <Grid item>
        <Box
          {...getRootProps()}
          sx={{
            border: "2px dashed",
            borderColor: isDragActive ? "primary.main" : "divider",
            borderRadius: 1,
            py: 5,
            px: 3,
            textAlign: "center",
            cursor: "pointer",
            bgcolor: isDragActive ? "action.hover" : "transparent",
            transition: "background-color 0.15s, border-color 0.15s",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
          }}
        >
          <input {...getInputProps()} />
          <AttachFileIcon sx={{ color: "text.secondary", fontSize: 32 }} />
          {file ? (
            <Typography variant="body2">
              <strong>{file.name}</strong> selected — drop a new file to replace
            </Typography>
          ) : (
            <Typography variant="body2" color="text.secondary">
              {isDragActive ? "Drop the CSV file here..." : "Choose CSV file or drag & drop"}
            </Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};
